import React from 'react';
import { Link } from 'gatsby';
import logo from '../static/images/logo/paladion.png';

const Header = () => (
  <div className="container">
    <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <nav className="navbar navbar-expand-lg navbar-classic">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="paladion" />
          </Link>
          <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbar-classic" aria-controls="navbar-classic" aria-expanded="false" aria-label="Toggle navigation">
            <span className="icon-bar top-bar mt-0" />
            <span className="icon-bar middle-bar" />
            <span className="icon-bar bottom-bar" />
          </button>
          <div className="collapse navbar-collapse" id="navbar-classic">
            <ul className="navbar-nav ml-auto mt-2 mt-lg-0 mr-lg-3">
              <li className="nav-item">
                <a className="nav-link" href="#home">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about">About us</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services">Services</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">Contact us</a>
              </li>
            </ul>
            <a href="#contact" className="btn btn-brand btn-rounded btn-sm">Request a Free Demo</a>
          </div>
        </nav>
      </div>
    </div>
  </div>

);

export default Header;
